// removed by extract-text-webpack-plugin
module.exports = {"emailContainer":"_3VxmmH1Qd4kxv6qdfN8u6r","mainTitle":"_34rXfSxn7_oAL9JsTBB9cc","emailHeaderContainer":"_1HbpGFLnbLBbzxEadGY1Qw","row":"_2aIsJaDnEAz8fBFaMxNhJa","column":"_3mfj11P6p07JiXE_N7ppqx","subject":"_1z-Hp5DVCSrA1xBX1RKHEd","emailStatus":"_1MvSHuujQwGkTj9cp3GOL2","emailBodyContainer":"_1fufmhoCOnbB7gwPbvVvpM","content":"GbSxupkkniufkxCKwpz6g","attachmentContainer":"_utorLkobJv_ATOp1g9q3","attachmentTable":"_1QnfZint2vlPXEFK7Y1ftU","title":"_1rRrIjCzetH7wb7Pr_qD0U"};


//////////////////
// WEBPACK FOOTER
// ./components/outbox/detailedEmail.scss
// module id = 1622
// module chunks = 0